/**
 * created by wang lei
 右合并单元格 页面
 *
 */
import React, {Component} from 'react';
import mergeRight from './mergeRight.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class MergeRightTool extends Component {
   constructor(props) {
        super(props);
        this.state = {
            mergeRight:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let mergeRight = this.props.editor.queryCommandState("mergeright")
        this.setState({mergeRight: mergeRight === 0});
    }

    /**
     * 监听编辑器点
     */
    listenContentClick(){
        let mergeRight = this.props.editor.queryCommandState("mergeright")
        this.setState({mergeRight: mergeRight === 0});
    }

    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.mergeRight ? "1":"0.3"}}>
                <img className={"editor-merge-right-tool-btn"} src={mergeRight}
                     onClick={()=>this.props.editor.execCommand("mergeright")}/>
                {this.state.mergeRight ? <style>{`
                .editor-merge-right-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-merge-right-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-merge-right-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-merge-right-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-merge-right-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-merge-right-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}